// extracted by mini-css-extract-plugin
export var restrictedWidthButton = "_tv-0";